export type CommentType = 'normal' | 'warning' | 'important';

export interface BizEkinetBookingInventoryCommentResponseArgs {
  id: number;
  inventory_pair_id: number;
  content: string;
  commented_by_id: number;
  commented_by_name: string;
  commented_at: string;
  status: CommentType;
  created_at: string;
  updated_at: string;
}

export interface BizEkinetBookingInventoryCommentArgs {
  id: number;
  inventoryPairId: number;
  content: string;
  commentedById: number;
  commentedByName: string;
  commentedAt: string;
  status: CommentType;
  createdAt: string;
  updatedAt: string;
}

export const convertBizEkinetBookingInventoryCommentResponseToArgs = (
  response: BizEkinetBookingInventoryCommentResponseArgs
): BizEkinetBookingInventoryCommentArgs => ({
  id: response.id,
  inventoryPairId: response.inventory_pair_id,
  content: response.content,
  commentedById: response.commented_by_id,
  commentedByName: response.commented_by_name,
  commentedAt: response.commented_at,
  status: response.status,
  createdAt: response.created_at,
  updatedAt: response.updated_at
});

export class BizEkinetBookingInventoryComment {
  id: number;
  inventoryPairId: number;
  content: string;
  commentedById: number;
  commentedByName: string;
  commentedAt: string;
  status: CommentType;
  createdAt: string;
  updatedAt: string;

  constructor(args: BizEkinetBookingInventoryCommentArgs) {
    this.id = args.id;
    this.inventoryPairId = args.inventoryPairId;
    this.content = args.content;
    this.commentedById = args.commentedById;
    this.commentedByName = args.commentedByName;
    this.commentedAt = args.commentedAt;
    this.status = args.status;
    this.createdAt = args.createdAt;
    this.updatedAt = args.updatedAt;
  }
}

export const commentTypeLabels: Record<CommentType, string> = {
  normal: '通常',
  warning: '要確認',
  important: '重要'
};
